export default "/images/f96f7a3ec6b7b88a92795eeb9e1a1845.avif";